<template>
    <base_location_modal :tabs_advanced="tabs_add">
        <template v-slot:location_general_info="{ location, name }">
            <glovo_general_tab :location="location"></glovo_general_tab>
        </template>

        <template v-slot:location_categories="{ location, name }">
            <location_super_categs :location="location"></location_super_categs>
        </template>

        <template v-slot:glovo_portal="{ location, name }">
            <glovo_portal :location="location"></glovo_portal>
        </template>

        <template v-slot:glovo_order_products="{ location, name }">
            <glovo_order_products :location="location"></glovo_order_products>
        </template>

    </base_location_modal>
</template>

<script>

import base_location_modal from "../../base/location_modal/base_location_modal";
import glovo_general_tab from "./tabs/glovo_general_tab";
import glovo_portal from "./tabs/glovo_portal";
import glovo_order_products from "./tabs/glovo_order_products.vue";
import Location_super_categs from "../../base/location_modal/tabs/location_super_categs";

export default {
    name: "glovo_location_modal",
    components : {
        Location_super_categs,
        base_location_modal,
        glovo_general_tab,
        glovo_portal,
        glovo_order_products
    },

    data () {
        return {
            tabs_add : [
                /*{
                    index : "glovo_portal",
                    title : this.__t('Панель Glovo'),
                },*/

                {
                    index : "glovo_order_products",
                    title : this.__t('G_ORDER_ATTACH'),
                },
            ]
        }
    },
}
</script>
